module.exports = __webpack_public_path__ + "static/media/Proxima-Nova-Bold.84abf853.woff";